import { render, staticRenderFns } from "./ReportBlockRow.vue?vue&type=template&id=bdd8972c"
import script from "./ReportBlockRow.vue?vue&type=script&lang=js"
export * from "./ReportBlockRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports